// @core/api/endpoints/notifications/get_delivery_report.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetDeliveryReportResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Get delivery report for notification
 * Retrieves detailed delivery information for a specific notification including all delivery attempts, timestamps, and status updates from providers.
 */
export async function GetDeliveryReport(
  notification_id: string,
  options?: RequestOptions
): Promise<GetDeliveryReportResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/notifications/:notification_id/delivery-report`;
  requestPath = requestPath.replace(':notification_id', encodeURIComponent(notification_id));
  const requestOptions = options;
  return client.get<GetDeliveryReportResponse>(requestPath, { ...requestOptions });
}
